export interface NpcSettingSuggestion {
  name?: string;
  desc?: string;
  prologue?: string;
  tone_id?: string;
  tone_name?: string;
  gender?: number;
  long_desc?: string;
  img_url?: string;
}

export enum Gender {
  NotDefined = 0,
  Male = 1,
  Female = 2,
  NoHuman = 3,
}

export enum NpcSettingSuggestScene {
  basic = 1, // 基础人设
  advanced = 2, // 高级人设
  NewBasic = 3, // 新版本基础人设
}

export interface SuggestNpcSettingsReq {
  user_id?: number;
  keywords?: string[];
  user_write?: NpcSettingSuggestion;
  text?: string;
  user_define_gender?: Gender;
  ignore_tone?: boolean;
  scene?: NpcSettingSuggestScene;
  full_coverage?: boolean;
}

export interface SuggestNpcSettingsResp {
  npc_settings?: NpcSettingSuggestion;
  first_sensitive_field?: number;
  user_define_gender?: Gender;
  trace_info?: string; // ai write 的trace_info
}

export interface IPromptTipsTag {
  name: string;
  tips?: string[];
  prompt?: string;
  img_url?: string;
}

export interface IPromptTips {
  type: string;
  name: string;
  tags: IPromptTipsTag[];
}

export interface GetUgcSettingsResp {
  data: {
    prompt_tips: IPromptTips[];
    x_group_url?: string;
    x_group_text?: string;
  };
}
